module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-app', [_c('v-navigation-drawer', {
    attrs: {
      "fixed": "",
      "temporary": ""
    },
    model: {
      value: (_vm.sideNav),
      callback: function($$v) {
        _vm.sideNav = $$v
      },
      expression: "sideNav"
    }
  }, [_c('v-list', [_vm._l((_vm.menuItems), function(item) {
    return _c('v-list-tile', {
      key: item.title,
      attrs: {
        "to": item.link
      }
    }, [_c('v-list-tile-action', [_c('v-icon', [_vm._v(_vm._s(item.icon))])], 1), _vm._v(" "), _c('v-list-tile-content', [_vm._v("\n          " + _vm._s(item.title) + "\n          ")])], 1)
  }), _vm._v(" "), (_vm.userIsAuthenticated) ? _c('v-list-tile', {
    on: {
      "click": _vm.onLogout
    }
  }, [_c('v-list-tile-action', [_c('v-tooltip', [_c('v-icon', {
    staticStyle: {
      "maxHeight": "8ex"
    },
    attrs: {
      "slot": "activator"
    },
    slot: "activator"
  }, [_vm._v("exit_to_app")]), _vm._v(" "), _c('span', [_vm._v("Log Out")])], 1)], 1), _vm._v(" "), _c('v-list-tile-content', [_vm._v("Logout")])], 1) : _vm._e()], 2)], 1), _vm._v(" "), _c('v-toolbar', {
    attrs: {
      "height": "100ex"
    }
  }, [_c('v-toolbar-side-icon', {
    staticClass: "hidden-sm-and-up ",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.sideNav = !_vm.sideNav
      }
    }
  }), _vm._v(" "), _c('v-toolbar-title', [_c('router-link', {
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "to": "/projects",
      "tag": "span"
    }
  }, [_c('img', {
    staticStyle: {
      "maxHeight": "8ex"
    },
    attrs: {
      "src": require("../static/img/official_icons/logo.png")
    }
  })])], 1), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-toolbar-items', {
    staticClass: "hidden-xs-only"
  }, [_vm._l((_vm.menuItems), function(item) {
    return _c('v-btn', {
      key: item.icon,
      attrs: {
        "flat": "",
        "to": item.link
      }
    }, [_c('v-avatar', [_c('v-tooltip', [_c('div', {
      attrs: {
        "slot": "activator"
      },
      slot: "activator"
    }, [_c('img', {
      staticStyle: {
        "maxHeight": "8ex"
      },
      attrs: {
        "src": item.icon,
        "alt": item.title
      }
    })]), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.title))])])], 1), _vm._v(" "), _c('v-spacer')], 1)
  }), _vm._v(" "), _c('v-spacer', {
    staticStyle: {
      "width": "50px"
    }
  }), _vm._v(" "), (_vm.userIsAuthenticated) ? _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": _vm.onLogout
    }
  }, [_c('v-avatar', [_c('v-tooltip', [_c('div', {
    attrs: {
      "slot": "activator"
    },
    slot: "activator"
  }, [_c('img', {
    staticStyle: {
      "maxHeight": "8ex"
    },
    attrs: {
      "src": '../static/img/official_icons/signout.png',
      "alt": 'Logout'
    }
  })]), _vm._v(" "), _c('span', [_vm._v("Sign Out")])])], 1)], 1) : _vm._e()], 2)], 1), _vm._v(" "), _c('main', [_c('router-view')], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2b894d22","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 84
// module chunks = 3